/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tired_Least_Kestrel_RadiateInputs */

const fr_tired_least_kestrel_radiate = /** @type {(inputs: Tired_Least_Kestrel_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère les drop-ins de tes membres`)
};

/**

* @param {Tired_Least_Kestrel_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tired_least_kestrel_radiate = /** @type {((inputs?: Tired_Least_Kestrel_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tired_Least_Kestrel_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tired_least_kestrel_radiate(inputs)
});